document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.acj-slideshow').forEach((slideshow) => {

    const slides = slideshow.querySelectorAll('.acj-slide');
    const progress = slideshow.querySelector('.acj-progress-bar');

    if (slides.length <= 1) return;

    let current = 0;
    let timer;
    let duration = 5000;

    function resetProgress() {
      if (!progress) return;

      progress.style.transition = 'none';
      progress.style.width = '0%';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          progress.style.transition = `width ${duration}ms linear`;
          progress.style.width = '100%';
        });
      });
    }

    function showSlide(index) {

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      current = index;
      resetProgress();
    }

    function nextSlide() {
      showSlide((current + 1) % slides.length);
    }

    function previousSlide() {
      showSlide((current - 1 + slides.length) % slides.length);
    }

    function startTimer() {
      clearInterval(timer);
      resetProgress();
      timer = setInterval(nextSlide, duration);
    }

    function stopTimer() {
      clearInterval(timer);
    }

    /* ---------- Swipe ---------- */

    let touchStartX = 0;

    slideshow.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    slideshow.addEventListener('touchend', (e) => {

      const distance = touchStartX - e.changedTouches[0].clientX;

      if (Math.abs(distance) < 50) return;

      if (distance > 0) {
        nextSlide();
      } else {
        previousSlide();
      }

      startTimer();

    }, { passive: true });

    /* ---------- Pause on Hover ---------- */

    //slideshow.addEventListener('mouseenter', stopTimer);
    //slideshow.addEventListener('mouseleave', startTimer);

    showSlide(0);
    startTimer();

  });

});